
import { Component, Mixins } from "vue-property-decorator";
import { Color, TextStyle } from "../../../../../../../base/domain/drawing";
import { default as TextPresentableObjectDrawerBase } from "./TextPresentableObjectDrawerBase.vue";

@Component
export default class TextDrawableObjectDrawerBase extends Mixins(TextPresentableObjectDrawerBase) {
  get textStyle(): TextStyle {
    const textStyle = this.readPropertyOrDefault(s => s.textStyle().getValue(), null);
    return textStyle
      ? new TextStyle(
        new Color(textStyle.fontStyle.color.value),
        textStyle.alignment,
        textStyle.fontStyle.font.size,
        null,
        textStyle.fontStyle.font.family,
      )
      : null;
  }
}
